<template>
  <div class="todo-wrapper" v-loading.lock.fullscreen="taskLoading">
    <van-button
      ref="button"
      @click="scrollBottom"
      round
      class="float-btn float-btn--scroll"
      icon="arrow-down"
    ></van-button>
    <div ref="moreMenu" class="float-more-wrap">
      <van-button
        round
        class="float-btn float-btn--more"
        icon="ellipsis"
        @click="showMoreMenu = !showMoreMenu"
      ></van-button>
      <transition name="float-menu-fade">
        <div v-show="showMoreMenu" class="float-menu">
          <div class="float-menu-item" @click="onMoreMenuClick('transfer')">
            <van-icon name="share-o" size="16" />
            <span>转派</span>
          </div>
          <div class="float-menu-item" @click="onMoreMenuClick('feedback')">
            <van-icon name="chat-o" size="16" />
            <span>问题反馈</span>
          </div>
          <!-- <div v-if="isInDetailUiGrayList" class="float-menu-item" @click="toggleDetailVersion">
            <van-icon name="exchange" size="16" />
            <span>切换至{{ useNewDetailVersion ? '旧版' : '新版' }}</span>
          </div> -->
        </div>
      </transition>
    </div>
    <div v-for="(todoItem, todoIndex) in todoComponent" :key="todoItem.taskId">
      <template v-if="!shouldUseCollapse">
        <div class="section-header">
          <div class="section-header__title">
            <span class="section-header__indicator"></span>
            <span class="section-header__text">{{ '待办详情' }}</span>
          </div>
          <el-tag v-if="todoItem.realTime" size="small" type="warning" effect="plain"
            >部分数据实时更新</el-tag
          >
        </div>
        <!-- 待办信息 -->
        <div>

          <!-- <van-cell title="处理人" :value="todoItem.ProcessUsers" /> -->
          <van-cell title="创建时间" :value="todoItem.CreateTime" />
          <!-- <div v-for="(infoItem) in todoItem.nodeBasicInfo" :key="infoItem.name"> -->
          <van-cell
            v-show="
              infoItem.data &&
              infoItem.name &&
              !infoItem.name.includes('流程ID') &&
              infoItem.name !== '任务ID'
            "
            v-for="infoItem in todoItem.nodeBasicInfo"
            :key="infoItem.name"
            :title="infoItem.name"
            :value="infoItem.data || '-'"
          />
          <!-- </div> -->
          <TodoView :todoIndex="todoIndex" :todoViewsData="todoItem.todoViewsData" />
        </div>
      </template>
      <!-- 待办操作 -->
      <div v-if="todoItem.operateFormSchema && todoItem.operateFormSchema.schema">
        <todo-form
          :ref="'todo-form-' + todoItem.taskId"
          :schema="todoItem.operateFormSchema.schema"
          :values="{
            ...todoItem.operateFormData,
            $context: {
              instanceId: todoItem.instanceId,
              parent_id: todoItem.parentId,
              parent_task_id: todoItem.ParentTaskId,
              service_name: todoItem.AjaxService,
              ProcessDefinitionKey: todoItem.ProcessDefinitionKey,
              taskId: todoItem.taskId,
              svckey: todoItem.FlowServiceKey || 'flowable',
              user: username,
              processUsers: todoItem.ProcessUsers,
              todoId: todoItem.todoId,
              todoName: todoItem.taskName || '',
              serviceUrl: todoItem.ServiceUrl,
              notice: todoItem.notice,
              ProcessDefinitionKey: todoList[0].ProcessDefinitionKey,
              CreateTime: todoList[0].CreateTime,
              ticketId,
              ticketStatus
            },
          }"
        />
      </div>
      <van-form v-for="operItem in todoItem.operateViewsData" v-else :key="operItem.name">
        <van-cell
          v-if="
            operItem.type === 'KVField' ||
            (!operItem.Type && !operItem.type) ||
            operItem.Type === 'KVField'
          "
          :label="operItem.name ? operItem.name + ':' : operItem.KeyName + ':'"
          label-width="120px"
          :value="operItem.data || operItem.Value"
        />

        <!-- input类型 -->
        <van-field
          v-else-if="operItem.type === 'TextArea'"
          v-model="operItem.data"
          type="textarea"
          :label="operItem.name + ':'"
        />

        <!-- link类型 兼容流程中间数据 -->
        <van-cell
          v-else-if="operItem.type === 'Link' || operItem.Type === 'Link'"
          :label="operItem.KeyName ? operItem.KeyName + ':' : operItem.name + ':'"
        >
          <el-link
            v-if="operItem.Value"
            :href="operItem.Value"
            class="f12"
            type="primary"
            target="_blank"
          >
            {{ operItem.Value }}
          </el-link>
          <el-link v-else :href="operItem.data" class="f12" type="primary" target="_blank">
            {{ operItem.data }}
          </el-link>
        </van-cell>

        <van-field
          readonly
          v-else-if="operItem.type === 'Radio'"
          :label="operItem.name ? operItem.name + ':' : ''"
        >
          <template #input>
            <van-radio-group v-model="operItem.data" class="flex-h-between w">
              <van-radio v-for="radio in operItem.options" :key="radio.name" :name="radio.data">
                {{ radio.name }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          readonly
          v-else-if="operItem.type === 'Checkbox'"
          :label="operItem.name ? operItem.name + ':' : ''"
        >
          <template #input>
            <van-checkbox-group v-model="operItem.data" class="flex-h-between w">
              <van-checkbox
                v-for="checkbox in operItem.options"
                :key="checkbox.name"
                :name="checkbox.data"
              >
                {{ checkbox.name }}
              </van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>
        <van-field
          v-else-if="operItem.type === 'RichEditor'"
          :label="operItem.name ? operItem.name + ':' : ''"
        >
          <quill-editor v-model="operItem.data" />
        </van-field>
      </van-form>
      <div class="action-bar">
        <div v-for="nodeItem in todoItem.nodeButton" :key="nodeItem.type + nodeItem.name">
          <van-button
            v-if="!nodeItem.hidden"
            v-loading.fullscreen.lock="fullscreenLoading"
            round
            class="action-btn action-btn--primary"
            :disabled="todoItem.disabled"
            @click="submitOperation(nodeItem, todoIndex)"
          >
            {{ nodeItem.name }}
          </van-button>
        </div>
        <van-button
          v-if="!todoItem.hideReset && !!Object.keys(todoItem.operateFormSchema || {}).length"
          round
          class="action-btn action-btn--default"
          @click="onClearForm(todoIndex)"
        >
          重置
        </van-button>
        <van-button
          v-if="!todoItem.hideHandover"
          :disabled="todoItem.disabled"
          round
          class="action-btn action-btn--secondary"
          @click="showHandoverTodo(todoIndex)"
        >
          待办转派
        </van-button>
        <van-button
          v-for="nodeItem in todoItem.extraButton"
          :key="nodeItem.type"
          v-loading.fullscreen.lock="fullscreenLoading"
          round
          class="action-btn action-btn--danger"
          :disabled="todoItem.disabled"
          @click="submitOperation(nodeItem, todoIndex, nodeItem.type === 'cancel')"
        >
          {{ nodeItem.name || '取消' }}
        </van-button>
      </div>
      <!-- 转派模态框 -->
      <van-dialog
        title="转派待办给他人"
        v-model="transferDialog"
        show-cancel-button
        append-to-body
        @confirm="submitTransferForm"
        @cancel="transferDialog = false"
      >
        <el-form ref="transferForm" :model="transferPerson" label-width="100px" class="mt10">
          <el-form-item
            label="接收人:"
            prop="name"
            :rules="{ required: true, message: '接收人不能为空', trigger: 'change' }"
          >
            <el-col :span="18">
              <user-select
                v-model="transferPerson.name"
                placeholder="请输入"
                multiple
                :allowPaste="false"
                confirm-oa-account
              ></user-select>
            </el-col>

            <el-col :span="4" style="margin-left: 5px">
              <van-icon name="add-o" @click="allProcessor" />
            </el-col>
          </el-form-item>
        </el-form>
      </van-dialog>

      <!-- 问题反馈框 -->
      <van-dialog title="工单问题反馈" v-model="questionDialog" :show-confirm-button="false">
        <van-form @submit="onSubmit">
          <van-field
            readonly
            clickable
            name="问题分类"
            label="问题分类"
            :value="formData.problem_type"
            placeholder="选择问题分类"
            @click="showPicker = true"
            required
            :rules="[{ required: true, message: '请填写问题分类' }]"
          />
          <van-popup v-model="showPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="troubleData"
              @cancel="showPicker = false"
              @confirm="onConfirms"
            />
          </van-popup>
          <van-field
            v-model="formData.problem_desc"
            name="问题描述"
            label="问题描述"
            type="textarea"
            placeholder="请输入问题描述"
            required
            :rules="[{ required: true, message: '请填写问题描述' }]"
          />
          <van-field name="uploader" label="文件上传">
            <template #input>
              <van-uploader
                v-model="formData.fileList"
                :max-size="100 * 1024 * 1024"
                @oversize="onOversize"
                @delete="onDelete"
                :after-read="afterRead"
                :before-delete="beforeDelete"
                :max-count="6"
                accept="image/*"
                :beforeRead="beforeRead"
                multiple
              />
            </template>
          </van-field>
          <div class="footerDialog">
            <van-button block @click="onClose">取消</van-button>
            <van-button block type="info" native-type="submit">确定</van-button>
          </div>
        </van-form>
      </van-dialog>
      <div v-if="!todoComponent.length && !taskLoading" class="mt10 text-c text-info">
        <van-divider
          >待办已结束，请前往已办页面查看，<el-link @click="gotoHistory" type="primary"
            >点击跳转</el-link
          ></van-divider
        >
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { Message } from 'element-ui';
import { Dialog } from 'vant';
import { findIndex, cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import UserSelect from '@/components/UserSelect';
import {
  getDataByNbroker,
  handoverTodo,
  queryNowN4,
  queryAllN4,
  getDataByNbrokerUrl,
  getVariables,
  feedbackTicketInfo,
  getDataByNbrokerGoUrl
} from '@/api/tickets/ticketsApi';
import { getTodoList } from '@/api/tickets/todoApi';
import { getFlowLogById, getSchemeDefinition } from '@/api/appDispose/planApi';
import TodoForm from '@/components/Formily/formilyTodoForm-new.vue';
import TodoView from './todoView.vue';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { addEndLog } from '@/api/flowSim/ticketsApi.js';
import { getRawFlowData } from '@/api/appDispose/planApi';
import { pageTranslator } from '@/utils/pageTranslator';

export default {
  name: 'CommonTodo',
  components: { TodoForm, UserSelect, TodoView, quillEditor },
  watch: {
    todoComponent: {
      handler(newVal) {
        this.$emit('update-todo-component', newVal);
      },
      deep: true,
    },
  },
  async mounted() {
    try {
        this.processGrayList = JSON.parse(this.getConfigItem('process_gray_list') || '[]')

    } catch (error) {

    }
    this.troubleData = JSON.parse(this.getConfigItem('problem_type')).map((item) => item.label);
    this.getLocalData();
    // this.getFlowHistory(this.instanceId);
    await this.getTodoDataList();
    this.handleScroll();

    // 记录进入页面时间
    this.recordPageVisit('enter');
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    document.addEventListener('scroll', this.handleScroll);
    this.saver = setInterval(() => {
      try {
        const todos = this.todoComponent.map(({ operateViewsData, taskId }) => {
          const todoRef = this.$refs[`todo-form-${taskId}`][0];
          return { operateViewsData, operateFormData: todoRef.getValues(), taskId };
        });
        localStorage.setItem(`taskId=${this.taskId}`, JSON.stringify(this.deleteNull(todos)));
      } catch (e) {}
    }, 2000);
    if (this.isRefresh) {
      this.timer = setInterval(() => {
        this.getTodoDataList();
      }, 20000);
    }

    // 监听VoiceAssistant数据更新事件（使用全局事件总线）
    this.$root.$on('voice-data-updated', this.handleVoiceDataUpdated);
  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScroll);
    // 记录离开页面时间
    this.recordPageVisit('leave');
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  computed: {
    ...mapGetters(['getConfigItem']),
    // 判断当前用户是否在待办详情UI灰度名单中
    isInDetailUiGrayList() {
      try {
        const detailUiGrayList = JSON.parse(this.getConfigItem('detailUiGrayList') || '[]');
        if (detailUiGrayList?.includes?.(sessionStorage.getItem('userid'))) {
          return true;
        }
      } catch (e) {}
      return false;
    },
    // 当前是否使用新版本
    useNewDetailVersion() {
      return localStorage.getItem('todoDetailVersionNew') !== 'false';
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.saver) {
      clearInterval(this.saver);
    }
    if (this.todoTimer.length) {
      this.todoTimer.forEach((item) => {
        clearInterval(item);
      });
    }
    // 移除VoiceAssistant事件监听器（使用全局事件总线）
    this.$root.$off('voice-data-updated', this.handleVoiceDataUpdated);
  },
  data() {
    return {
      formData: {
        problem_type: '',
        problem_desc: '',
        fileList: [],
      },
      questionDialog: false,
      showPicker: false,
      showMoreMenu: false,
      // 悬浮按钮（回到顶部 / 更多菜单）显隐的内部记录值：
      // 只用于比对避免重复操作 DOM，不参与模板渲染，改动它不会触发组件重渲染
      floatBtnHiddenState: false,
      scrollRaf: null,
      floatBtnResizeObserver: null,
      floatBtnTimers: [],
      floatBtnScroller: null,
      touchEndTimer: null,
      touchMoveLocked: false,
      // 组件是否已销毁，用于拦截延迟回调
      floatBtnTorn: false,
      isShowPreview: false,
      troubleData: [],
      ImgData: [],
      imageUrl: '',
      taskLoading: true,
      todoList: [],
      todoComponent: [],
      transferDialog: false,
      transferPerson: {
        name: '',
      },
      taskId: this.$route.query.taskId || '',
      schemeManager: '',
      currTodo: {},
      timer: null,
      nodeList: [],
      localData: [],
      fullscreenLoading: false,
      transDisabled: false,
      username: sessionStorage.getItem('userid'),
      flowLogData: [],
      todoTimer: [],
      currTodoComponent: {},
      container: document.querySelector('body'),
      showButton: false,
      ProcessDefinitionKey: '',
      pageVisitKey: `pageVisit_${this.$route.query.taskId || ''}`,
      processGrayList: [],
      // sessionStorage
    };
  },
  props: {
    ticketId: {
      type: String,
      default: '',
    },
    instanceId: {
      type: String,
      default: '',
    },
    ticketStatus: {
      type: String,
      default: '',
    },
    todoId: {
      type: String,
      default: '',
    },
    isSim: {
      type: Boolean,
      default: false,
    },
    ticketDealer: {
      type: Array,
      default: () => [],
    },
    shouldUseCollapse: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // 记录页面访问时间（进入/离开）
    recordPageVisit(type) {
      try {
        if (!this.processGrayList?.includes(this.ProcessDefinitionKey)) return;
        var records = JSON.parse(sessionStorage.getItem(this.pageVisitKey) || '[]');
        records.push({
          type: type,
          time: new Date().toLocaleString()
        });
        sessionStorage.setItem(this.pageVisitKey, JSON.stringify(records));
      } catch (e) {}
    },

    // 监听页面可见性变化
    handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        this.recordPageVisit('leave');
      } else if (document.visibilityState === 'visible') {
        this.recordPageVisit('enter');
      }
    },

    onMoreMenuClick(action) {
      this.showMoreMenu = false;
      if (action === 'transfer') {
        this.showHandoverTodo(0);
      } else if (action === 'feedback') {
        this.feedback();
      }
    },
    // 切换详情页版本
    toggleDetailVersion() {
      this.showMoreMenu = false;
      const currentVersion = this.useNewDetailVersion;
      if (currentVersion) {
        this.$toast({ message: '切换至旧版', duration: 1500 });
        localStorage.setItem('todoDetailVersionNew', 'false');
        try {
          const { aegis } = this.$store.state.user;
          if (aegis) {
            aegis.infoAll({
              msg: JSON.stringify({
                action: 'switch_todo_detail_version',
                from: 'new',
                to: 'old',
                userid: sessionStorage.getItem('userid'),
                timestamp: new Date().toISOString()
              }),
              ext1: 'switch-todo-detail-version',
              trace: 'switch-todo-detail-version',
            });
          }
        } catch (e) {}
      } else {
        this.$toast({ message: '切换至新版', duration: 1500 });
        localStorage.setItem('todoDetailVersionNew', 'true');
        try {
          const { aegis } = this.$store.state.user;
          if (aegis) {
            aegis.infoAll({
              msg: JSON.stringify({
                action: 'switch_todo_detail_version',
                from: 'old',
                to: 'new',
                userid: sessionStorage.getItem('userid'),
                timestamp: new Date().toISOString()
              }),
              ext1: 'switch-todo-detail-version',
              trace: 'switch-todo-detail-version',
            });
          }
        } catch (e) {}
      }
      // 强制刷新以加载对应版本
      setTimeout(() => window.location.reload(), 300);
    },
    // 选择当前全部处理人
    allProcessor() {
      this.$notify({ type: 'success', message: '已选择当前工单全部处理人' });
      this.transferPerson.name = this.todoComponent[0].ProcessUsers;
    },

    feedback() {
      this.questionDialog = true;
    },
    onConfirms(value) {
      this.formData.problem_type = value;
      this.showPicker = false;
    },
    onSubmit() {
      Dialog.confirm({
        message: '提交后将自动拉群跟进工单问题，是否确认？',
      })
        .then(async () => {
          await feedbackTicketInfo({
            SceneType: '平台自用',
            TicketDescription: `异常工单问题反馈，问题描述：${this.formData.problem_desc}，工单号：${this.ticketId}`,
            ProcessDefinitionKey: 'trouble_ticket_feedback',
            TicketLevel: '3',
            TicketTitle: `【${this.ticketId}】异常工单问题反馈`,
            UserInfo: {
              Concern: this.$store.state.user.name,
              Creator: this.$store.state.user.name,
              Deal: this.$store.state.user.name,
            },
            SchemeNameCn: '工单问题反馈',
            CustomVariables: {
              problem_type: this.formData.problem_type,
              problem_ticket_id: this.ticketId,
              problem_img: this.ImgData,
              problem_desc: this.formData.problem_desc,
            },
            VueOperateUser: this.$store.state.user.name,
          });
          this.$toast('异常反馈成功');
          this.questionDialog = false;
        })
        .catch(() => {});
    },
    onClose() {
      this.questionDialog = false;
      this.formData.problem_type = this.formData.problem_desc = '';
      this.formData.fileList = [];
    },
    afterRead(file) {
      console.log('开始执行', file);
      if (Array.isArray(file)) {
        file.forEach((item) => {
          item.status = 'uploading';
          item.message = '上传中...';
          This.uploadMaterialImg(item);
        });
      } else {
        file.status = 'uploading';
        file.message = '上传中...';
        this.uploadMaterialImg(file);
      }
    },

    // 图片上传
    uploadMaterialImg(imgFile) {
      let This = this;
      let reqData = new FormData();
      let UserId = sessionStorage.getItem('userid');
      if (imgFile.length) {
        imgFile.map((item) => {
          let newName = this.type + item.file.name;
          const newFile = new File([item.file], newName);
          reqData.append('file', item.file);
        });
      } else {
        let newName = this.type + imgFile.file.name;
        const newFile = new File([imgFile.file], newName);
        reqData.append('file', newFile);
      }
      axios
        .post(`/relay/upload/img?UserId=${UserId}`, reqData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          if (res.status == 200) {
            imgFile.status = 'done';
            imgFile.message = '上传成功';
            this.formData.fileList.push({ url: res.data[0].path, name: imgFile.file.name });
            this.ImgData.push({
              response: {
                FileList: [
                  {
                    name: imgFile.file.name,
                    status: imgFile.status,
                    uid: imgFile.uid,
                    url: res.data[0].path,
                  },
                ],
              },
            });
            This.$toast('照片上传成功');
          } else {
            This.$toast('照片上传失败，请重新上传！');
          }
          console.log(this.formData, 'formData');
        })
        .catch((error) => {
          imgFile.status = 'failed';
          imgFile.message = '上传失败';
          This.$toast('照片上传失败，请重新上传！');
        });
    },

    onOversize(file) {
      this.$toast('文件大小不能超过 10M');
    },

    beforeDelete() {
      return true;
    },
    //删除图片
    onDelete() {
      console.log(this.formData, '???????');
    },
    //点击图片放大浏览
    previewImage(url) {
      console.log(url, 'url');
      this.isShowPreview = true;
      this.imageUrl = [url];
    },

    beforeRead(file) {
      console.log(file, 'file');
      const type = ['image/jpeg', 'image/png', 'image/jpg'];

      let isImage = true;
      if (file.length) {
        isImage = file.find((files) => type.includes(files.type));
      } else {
        isImage = type.includes(file.type);
      }
      // const isLt2M = file.size / 1024 / 1024 < 100;

      if (!isImage) {
        this.$toast('上传图片格式不正确');
      }

      // if (!isLt2M) {
      //   this.$toast('图片大小不能超过 100MB!');
      // }

      return isImage;
    },
    // 判断是否已滚动到（接近）页面底部，兼容不同机型滚动实现差异
    isPageAtBottom(scroller) {
      const OFFSET = 80;
      const el = scroller || this.getPageScroller();
      const isDocumentScroller =
        el === document.documentElement || el === document.body;

      // 可视区底边：优先用真实滚动容器的底边，避免容器非全屏时误判
      let visibleBottom =
        document.documentElement.clientHeight ||
        window.innerHeight ||
        document.body.clientHeight ||
        0;
      if (!isDocumentScroller && typeof el.getBoundingClientRect === 'function') {
        const scrollerRect = el.getBoundingClientRect();
        if (scrollerRect && scrollerRect.bottom > 0) {
          visibleBottom = Math.min(visibleBottom, scrollerRect.bottom);
        }
      }

      // 方案一：用内容区底部与可视区底边的相对位置判断
      // 不依赖 scrollTop 的取值来源，规避各机型 documentElement/body 差异
      const root = this.$el;
      if (root && typeof root.getBoundingClientRect === 'function') {
        const rect = root.getBoundingClientRect();
        // 高度为 0 说明内容尚未渲染完成，交给下面的数值兜底判断
        if (rect && rect.height > 0) {
          return rect.bottom - visibleBottom <= OFFSET;
        }
      }

      // 方案二：兜底使用传统数值比较
      if (isDocumentScroller) {
        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0;
        const scrollHeight = Math.max(
          document.documentElement.scrollHeight || 0,
          document.body.scrollHeight || 0
        );
        return scrollHeight - OFFSET <= scrollTop + visibleBottom;
      }
      return el.scrollHeight - OFFSET <= el.scrollTop + el.clientHeight;
    },

    // 找出真正产生滚动的容器（部分机型实际滚动的是内部容器而不是 document）
    getPageScroller() {
      const docEl = document.documentElement;
      const body = document.body;
      const canScroll = (el) => !!el && el.scrollHeight - el.clientHeight > 2;

      let node = this.$el ? this.$el.parentElement : null;
      while (node && node !== body && node !== docEl) {
        let overflowY = '';
        try {
          overflowY = window.getComputedStyle(node).overflowY;
        } catch (e) {}
        if ((overflowY === 'auto' || overflowY === 'scroll') && canScroll(node)) {
          return node;
        }
        node = node.parentElement;
      }
      if (canScroll(docEl)) return docEl;
      if (canScroll(body)) return body;
      return docEl;
    },

    // rAF 节流，避免滚动过程中高频计算
    onPageScroll() {
      if (this.scrollRaf) return;
      const cb = () => {
        this.scrollRaf = null;
        this.handleScroll();
      };
      if (typeof window.requestAnimationFrame === 'function') {
        this.scrollRaf = window.requestAnimationFrame(cb);
      } else {
        this.scrollRaf = setTimeout(cb, 16);
      }
    },

    // 页面是否可以滚动（内容高度大于视口）
    // 页面本身不可滚动时不能隐藏按钮，否则短页面会看不到「更多」里的问题反馈入口
    isPageScrollable(scroller) {
      const viewportHeight =
        document.documentElement.clientHeight ||
        window.innerHeight ||
        document.body.clientHeight ||
        0;
      const el = scroller || this.getPageScroller();
      if (el === document.documentElement || el === document.body) {
        const scrollHeight = Math.max(
          document.documentElement.scrollHeight || 0,
          document.body.scrollHeight || 0
        );
        return scrollHeight - viewportHeight > 2;
      }
      return el.scrollHeight - el.clientHeight > 2;
    },

    // 取悬浮按钮真实 DOM：ref 可能拿到组件实例，统一用 $el 兜底
    getFloatBtnEls() {
      const toEl = (ref) => (ref && ref.$el ? ref.$el : ref);
      return [toEl(this.$refs.button), toEl(this.$refs.moreMenu)].filter(
        (el) => el && el.classList
      );
    },

    handleScroll() {
      if (this.floatBtnTorn) return;
      // 只计算一次滚动容器，避免重复读取布局触发多次重排
      const scroller = this.getPageScroller();
      const hidden = this.isPageScrollable(scroller) && this.isPageAtBottom(scroller);
      if (hidden === this.floatBtnHiddenState) return;
      this.floatBtnHiddenState = hidden;
      // 直接操作 DOM class，不写入响应式数据：
      // 写响应式数据会触发父组件重渲染，而 <todo-form :values="{...}"> 的内联对象每次渲染都是新引用，
      // 会命中子组件 values 侦听器执行 setValues，把用户已填内容覆盖回初始值
      this.getFloatBtnEls().forEach((el) => {
        if (hidden) {
          el.classList.add('hide');
        } else {
          el.classList.remove('hide');
        }
      });
      // 隐藏时顺手收起展开的菜单，避免残留
      if (hidden && this.showMoreMenu) {
        this.showMoreMenu = false;
      }
    },

    gotoHistory() {
      const url = this.$router.resolve({
        query: {
          ...this.$route.query,
          isHistory: '1',
        },
      });
      console.log(url);
      location.href = url.href;
    },
    scrollBottom(e) {
      scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth',
      });
    },
    getLocalData() {
      try {
        const localStr = localStorage.getItem(`taskId=${this.taskId}`) || '[]';
        this.localData = JSON.parse(localStr);
      } catch {}
    },
    isUserHasAuth() {
      this.todoComponent.forEach((todoItem) => {
        const nowUser = this.username;
        // 如果是配置了管理员，则管理员拥有所有权限
        if (this.schemeManager && this.schemeManager.includes(nowUser)) {
          todoItem.disabled = false;
        }
        // 如果是之前没有配置权限的待办，则不做权限限制
        if (!todoItem.todoRole.name && todoItem.AjaxService !== 'AjaxExceptionTodo') {
          todoItem.disabled = false;
        }
        // 如果是之前没有配置权限的待办，则不做权限限制
        if (todoItem.todoRole.name === 'no' && todoItem.AjaxService !== 'AjaxExceptionTodo') {
          todoItem.disabled = false;
        }
        if (
          todoItem.todoRole.name === 'onlyDealer' &&
          todoItem.AjaxService !== 'AjaxExceptionTodo'
        ) {
          const nowUser = this.username;
          const pattern = /\(.+\)/;
          let users = todoItem.ProcessUsers;
          // 字符串情况统一处理成数组
          if (typeof todoItem.ProcessUsers === 'string') {
            users = todoItem.ProcessUsers.split(';');
          }
          users.forEach((user) => {
            if (user.replace(pattern, '') === nowUser) {
              todoItem.disabled = false;
            }
          });
        } else if (todoItem.todoRole.name === 'onlyNowN4') {
          const nowUser = this.username;
          queryNowN4().then((res) => {
            const users = res.data.FuncResult.Data;
            if (users.includes(nowUser)) {
              todoItem.disabled = false;
            }
          });
        } else if (todoItem.todoRole.name === 'allN4') {
          const nowUser = this.username;
          queryAllN4().then((res) => {
            const users = res.data.FuncResult.Data;
            if (users.includes(nowUser)) {
              todoItem.disabled = false;
            }
          });
        } else if (todoItem.todoRole.name === 'perm') {
          const nowUser = this.username;
          // const positionName = todoItem.todoRole.authProp.positionName;
          const { className } = todoItem.todoRole.authProp;
          for (let i = 0; i < className.length; i++) {
            const queryParams = {
              // PositionName: positionName,
              PositionName: 'Flowable待办权限角色控制',
              Properties: {
                待办分组名称: className[i],
              },
            };
            queryUserListByRole(queryParams).then((res) => {
              const users = res.data.Result;
              if (users.includes(nowUser)) {
                todoItem.disabled = false;
              }
            });
          }
        } else if (
          todoItem.todoRole.name === 'dealerAndConcern' &&
          todoItem.AjaxService !== 'AjaxExceptionTodo'
        ) {
          const nowUser = this.username;
          const pattern = /\(.+\)/;

          const users = this.ticketDealer;
          // 字符串情况统一处理成数组
          if (Array.isArray(this.ticketDealer)) {
            users.forEach((user) => {
              if (user.replace(pattern, '') === nowUser) {
                todoItem.disabled = false;
              }
            });
          }
        }
      });
    },
    handleCheckAllChange(checked, todoIndex, opIndex) {
      // 这里支持点击全选框后一键全选和反选
      this.todoComponent[todoIndex].operateViewsData[opIndex].data = checked
        ? this.todoComponent[todoIndex].operateViewsData[opIndex].options.map((x) => x.data)
        : [];
      this.isIndeterminate = false;
    },

    // 获取待办信息
    async getTodoDataList() {
      // if (this.todoId) {
      //   this.getTodoTaskDataById();
      // } else {
      await this.getTodoTaskData();
      // }
    },

    // 获取流程历史
    async getFlowHistory(instanceId) {
      try {
        const result = await getFlowLogById(instanceId, true);
        this.flowLogData = result.data;
        if (this.ticketStatus === 'END' && this.isForceEnd === '1') {
          this.flowLogData.push({
            TaskName: '流程结束(强制结单)',
            TaskStatus: '已完成',
            Note: this.forceEndReason,
            Operator: this.forceEndOperator,
            CreateTime: this.endTime,
            EndTime: this.endTime,
          });
        }
      } catch (err) {}
    },

    // 通过todoId取得待办数据
    async getTodoTaskDataById() {
      try {
        const result = await getTodoList({ TaskId: this.todoId });

        const { List } = result.data;
        // this.todoComponent = [];
        if (List.length) {
          this.todoList = List;
          if (!this.todoComponent.some((item) => item.taskId === List[0].TaskId)) {
            await this.getTodoTaskConfig(List[0], 0, '');
          }
        }
        this.isUserHasAuth();
      } catch (err) {}
    },

    // 获取该工单下的待办数据
    async getTodoTaskData() {
      try {
        this.taskLoading = true;
        const result = await getTodoList({ TaskId: this.todoId });
        const todoList = result.data.List;
        this.ProcessDefinitionKey = todoList?.[0]?.ProcessDefinitionKey || '';

        // 没有data，则该单是已结单状态
        if (todoList) {
          // const todoList = data;
          // this.todoComponent = [];
          if (todoList.length) {
            this.todoList = todoList;
            // 去掉完成的待办
            this.todoComponent = this.todoComponent.filter(
              (item) =>
                todoList.some((todo) => todo.TaskId === item.taskId) ||
                !todoItem.ProcessUsers.split(';').includes(this.username)
            );

            // 检查taskId，新增的才更新
            for (let i = 0; i < todoList.length; i++) {
              const todo = todoList[i];
              const schemeQueryData = {
                ResultColumns: {
                  FlowData: '',
                  Manager: '',
                },
                SearchCondition: {
                  SchemeName: todo.ProcessDefinitionKey,
                },
                Sorts: [],
                Limit: {
                  Size: 20,
                  Start: 0,
                },
              };
              const schemeFlowData = await getSchemeDefinition(schemeQueryData);
              const schemeRawData = await getRawFlowData(this.instanceId);
              this.schemeManager = schemeFlowData.data.List[0].Manager;
              // 将 schemeFlowData 传递给父组件
              this.$emit('scheme-data-loaded', schemeFlowData.data.List[0]);
              const { nodeList } = schemeRawData.data.childShapes;
              this.nodeList = nodeList || [];
              const todoAuthRole = {
                name: '',
                authProp: {
                  positionName: '',
                  className: '',
                },
              };
              for (let j = 0; j < nodeList.length; j++) {
                if (nodeList[j].id === todo.TaskKey) {
                  if (nodeList[j].properties.authPermRole) {
                    todoAuthRole.name = nodeList[j].properties.authPermRole;
                  }
                  if (nodeList[j].properties.positionName) {
                    todoAuthRole.authProp.positionName = nodeList[j].properties.positionName;
                  }
                  if (nodeList[j].properties.className) {
                    todoAuthRole.authProp.className = nodeList[j].properties.className;
                  }
                  break;
                }
              }
              if (!this.todoComponent.some((item) => item.taskId === todo.TaskId)) {
                await this.getTodoTaskConfig(todo, i, todoAuthRole);
              }
            }
            this.isUserHasAuth();
            this.$emit('title-change', this.todoComponent[0] && this.todoComponent[0].todoName);
          } else {
            this.todoComponent = [];
          }
        } else {
          this.todoComponent = [];
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.taskLoading = false;
      }
    },

    // 通过nbroker取得配置中心的待办信息
    async getTodoTaskConfig(todoData, index, todoRole) {
      try {
        const url = todoData.HandleUrl || '';
        let todoConfigResult = {};
        if (url?.includes('nbrokergo')) {
          const path = url.match(/\/\/(\S*)(:9701)/)[1] || '';
          const goParams = {
            Args: {},
            Ctx: {
              InstanceId: todoData.InstanceId,
              MethodName: 'Query',
              ParentId: todoData.ParentInstanceId,
              ParentTaskId: todoData.ParentTaskId,
              ServiceName: todoData.AjaxService,
              Svckey: todoData.FlowServiceKey || 'flowable',
              TaskId: todoData.TaskId,
            },
          };
          // 外部系统待办（ExternalTodo）走 nbrokergo 时，ServiceName 固定为 'ExternalTodo'
          if (todoData.TodoKey === 'ExternalTodo') {
            goParams.Ctx.ServiceName = 'ExternalTodo';
          }
          todoConfigResult = await getDataByNbrokerGoUrl(`/${path}`, goParams);
          console.log(todoConfigResult,"dddd");
          
          const { data: result, msg: errInfo } = todoConfigResult;
          // if (errInfo) {
          //   throw new Error(JSON.stringify(errInfo));
          // }
          if (result.operate_views) {
            for (let i = 0; i < result.operate_views.length; i++) {
              const operateItem = result.operate_views[i];
              if (operateItem.type == 'Select' && operateItem.options_url != '') {
                result.operate_views[i] = await this.getSelectRemoteData(
                  operateItem,
                  operateItem.options_url,
                );
              }
              if (operateItem.type == 'Upload' && !Array.isArray(operateItem.data)) {
                result.operate_views[i].data = [];
              }
            }
          }

          this.handleTodoComponentData(result, todoData, index, todoRole);
          return;
        }
        const params = {
          context: {
            service_name: todoData.AjaxService,
            method_name: 'query',
            instanceId: todoData.InstanceId,
            taskId: todoData.TaskId,
            parent_id: todoData.ParentInstanceId,
            parent_task_id: todoData.ParentTaskId,
            svckey: todoData.FlowServiceKey || 'flowable',
            nodeId: todoData.TaskKey,
          },
          args: {},
        };
        if (todoData.TodoKey === 'ExternalTodo') {
          params.context.service_name = 'ExternalTodo';
        }

        // 这里不再直接通过http请求的方式访问nBroker接口，而是通过relay进行转发
        if (todoData.HandleUrl) {
          // todoConfigResult = await axios.post(todoData.HandleUrl, params);
          todoConfigResult = await getDataByNbrokerUrl(params, todoData.HandleUrl);
        } else {
          todoConfigResult = await getDataByNbroker(params);
        }

        const { result, exc_info: errInfo } = todoConfigResult.data;
        this.$store.dispatch('voiceAI/updateVoiceAIConfig', { result: JSON.stringify(result) });

        if (errInfo) {
          throw new Error(JSON.stringify(errInfo));
        }
        if (result.operate_views) {
          for (let i = 0; i < result.operate_views.length; i++) {
            const operateItem = result.operate_views[i];
            if (operateItem.type == 'Select' && operateItem.options_url != '') {
              result.operate_views[i] = await this.getSelectRemoteData(
                operateItem,
                operateItem.options_url,
              );
            }
            if (operateItem.type == 'Upload' && !Array.isArray(operateItem.data)) {
              result.operate_views[i].data = [];
            }
          }
        }
        this.handleTodoComponentData(result, todoData, index, todoRole);
      } catch (err) {
        console.log(err);
        this.$toast({
          type: 'error',
          message: `从nbroker获取待办配置信息接口出错：${err.message}`,
        });
      }
    },

    deleteNull(obj) {
      try {
        return JSON.parse(JSON.stringify(obj), (key, value) => {
          if (value === null || value === '' || (Array.isArray(value) && value.length === 0))
            return undefined;
          return value;
        });
      } catch (e) {
        return {};
      }
    },

    // 处理配置中心返回的待办处理数据
    handleTodoComponentData(protocol, todoData, index, todoRole) {
      this.localData.find(({ taskId }) => console.log(taskId, todoData.TaskId)) || {};
      console.log(this.localData, todoData.TaskId, 222);
      const localData = this.localData.find(({ taskId }) => taskId === todoData.TaskId) || {};
      if (protocol) {
        const todoTmp = {
          nodeBasicInfo: [],
          todoViewsData: [],
          operateFormSchema: {},
          operateFormData: {},
          nodeButton: [],
          extraButton: [],
          operateViewsData: [],
        };
        if (todoRole.name === 'allN4') {
          todoTmp.roleLabel = '仅N4人员';
        } else if (todoRole.name === 'onlyNowN4') {
          todoTmp.roleLabel = '仅当前时段N4值班人员';
        } else if (todoRole.name === 'onlyDealer') {
          todoTmp.roleLabel = '仅处理人';
        } else if (todoRole.name === 'perm') {
          const classNameString = todoRole.authProp.className.join(';');
          todoTmp.roleLabel = `仅${classNameString}人员`;
        } else if (todoData.AjaxService) {
          todoTmp.roleLabel = '仅管理员';
        } else {
          todoTmp.roleLabel = ''; // 如果是没有配置，则这里置为空
        }
        todoTmp.taskId = todoData.TaskId;
        todoTmp.todoName = todoData.TodoName;
        todoTmp.taskName = todoData.TaskName;
        todoTmp.ProcessUsers = todoData.ProcessUsers;
        todoTmp.CreateTime = todoData.CreateTime;
        todoTmp.ParentTaskId = todoData.ParentTaskId;
        todoTmp.instanceId = todoData.InstanceId;
        todoTmp.AjaxService = todoData.AjaxService;
        todoTmp.ParentTaskId = todoData.ParentTaskId;
        todoTmp.FlowServiceKey = todoData.FlowServiceKey;
        todoTmp.ProcessDefinitionKey = todoData.ProcessDefinitionKey;
        const { properties } = this.nodeList.find((item) => item.id === todoData.TaskKey) || {};
        todoTmp.TodoType = properties && properties.todoType;
        todoTmp.nodeBasicInfo = protocol.basic_views;
        const taskName = this.getParentTaskName(todoData.ParentTaskId);
        todoTmp.nodeBasicInfo.push({
          data: taskName,
          name: '父节点名称',
        });
        todoTmp.todoViewsData = protocol.todo_views;
        todoTmp.ServiceName = protocol.service_name;
        todoTmp.ServiceUrl = protocol.service_url;
        todoTmp.TaskKey = todoData.TaskKey;
        todoTmp.todoId = todoData.Id;
        todoTmp.notice = protocol.notice;

        let closeSaver = false;
        protocol.operate_views.forEach((item) => {
          if (item.type === 'Button') {
            todoTmp.nodeButton.push(item);
            item.callbackLink && (todoTmp.link = item.callbackLink);
            todoTmp.submitTips = item.submitTips;
          } else if (item.type === 'upload') {
            todoTmp.nodeButton.push(item);
          } else if (item.type === 'download') {
            todoTmp.nodeButton.push(item);
          } else if (item.type === 'cancel') {
            todoTmp.extraButton.push(item);
          } else if (item.type === 'handover') {
            todoTmp.hideHandover = item.hidden;
            this.todoList[index].handoverMethod = item.callback_method;
          } else if (item.type === 'reset') {
            todoTmp.hideReset = item.hidden;
          } else if (item.type === 'closeSaver') {
            closeSaver = item.value;
          } else {
            todoTmp.operateViewsData.push(item);
          }
        });
        if (protocol.operate_form_schema) {
          todoTmp.operateFormSchema = protocol.operate_form_schema;
          todoTmp.operateFormData =
            properties && properties.optimized
              ? {
                  ...this.deleteNull(protocol.operate_form_data),
                  ...((properties && properties.closeSaver) || closeSaver
                    ? {}
                    : this.deleteNull(localData.operateFormData || {})),
                }
              : this.deleteNull(protocol.operate_form_data);
          todoTmp.initData = cloneDeep(todoTmp.operateFormData);
          this.startPolling(todoData.TaskKey, Object.keys(protocol.operate_form_data), todoTmp,todoData);
        }
        todoTmp.todoRole = todoRole;
        todoTmp.disabled = true;
        this.todoComponent.splice(index, 0, todoTmp);
        if (properties && (properties.closeSaver || properties.optimized)) return;

        setTimeout(() => {
          this.todoComponent[index].operateFormData = Object.keys(localData.operateFormData || {})
            .length
            ? {
                ...this.deleteNull(protocol.operate_form_data),
                ...this.deleteNull(localData.operateFormData),
              }
            : this.deleteNull(protocol.operate_form_data);
        }, 100);
      }
    },
    onClearForm(index) {
      this.$dialog
        .alert({
          message: '重置表单数据为默认值，是否确认？',
          type: 'warning',
          showCancelButton: true,
        })
        .then(() => {
          this.$refs[`todo-form-${this.todoComponent[index].taskId}`][0].reset();
          this.todoComponent[index].operateFormData = {
            ...cloneDeep(this.todoComponent[index].initData),
          };
          this.$refs[`todo-form-${this.todoComponent[index].taskId}`][0].setValues(
            cloneDeep(this.todoComponent[index].initData)
          );
          localStorage.removeItem(`taskId=${this.taskId}`);
          // clearInterval(this.saver);
        })
        .catch(() => {});
    },
    async startPolling(todoKey, dataList, todoTmp, todoDatas) {
      const todoData = todoTmp;
      const childId = todoDatas.InstanceId;
      const schemeRawData = await getRawFlowData(childId);
      const newList = schemeRawData.data.childShapes.nodeList
      const newId = newList.find(item => item.id === todoDatas.TaskKey) || {};
      const { properties } = this.nodeList.find((item) => item.id === todoKey) || {};
      if (properties && properties.real_time_values && properties.real_time_values.length) {
        const timer = setInterval(async () => {
          try {
            const res = (await getVariables(properties.real_time_values, this.instanceId)) || {};
            const value = this.$refs[`todo-form-${todoTmp.taskId}`][0].getValues();
            // todoTmp.operateFormData = {
            //   ...todoTmp.operateFormData,
            //   ...this.deleteNull(res),
            // };
            this.$nextTick(() => {
              this.$refs[`todo-form-${todoTmp.taskId}`][0].values = this.deleteNull({
                ...this.deleteNull(res),
              });
              // todoTmp.operateFormData = this.$refs[`todo-form-${todoTmp.taskId}`][0].getValues()
            });
          } catch (e) {}
        }, 5000);
        todoData.realTime = true;
        this.todoTimer.push(timer);
      } else if (newId.properties && newId.properties.real_time_values && newId.properties.real_time_values.length) {
        const timer = setInterval(async () => {
          try {
            const res = (await getVariables(newId.properties.real_time_values, childId)) || {};
            const value = this.$refs[`todo-form-${todoTmp.taskId}`][0].getValues();
            this.$nextTick(() => (this.$refs[`todo-form-${todoTmp.taskId}`][0].values = this.deleteNull({
              ...this.deleteNull(res),
            })));
          } catch (e) {}
        }, 5000);
        todoData.realTime = true;
        this.todoTimer.push(timer);
      }
    },
    getParentTaskName(id) {
      let res = '';
      this.flowLogData.map((item) => {
        if (item.TaskId == id) {
          res = item.TaskName;
        }
      });
      return res;
    },

    // 提交待办操作
    async submitOperation(item, todoIndex, skipValidate = false) {
      const currTodo = this.todoList[todoIndex];
      const currTodoComponent = this.todoComponent[todoIndex];
      let processData = {};
      if (currTodoComponent.operateFormSchema && currTodoComponent.operateFormSchema.schema) {
        const todoForm = this.$refs[`todo-form-${currTodo.TaskId}`][0];
        if (!skipValidate) {
          try {
            await todoForm.validate();
          } catch (e) {
            this.$message.error('请填写必填项后再提交');
            const el = document.querySelector('.formily-todo div[validatestatus="error"]');
            window?.scrollTo?.({
              top: el.offsetTop, //需要父元素设置postion(relative、absolute、fixed)
              behavior: 'smooth',
            });
            return;
          }
        }
        processData = todoForm.getValues();
      } else {
        currTodoComponent.operateViewsData.forEach((operateItem) => {
          processData[operateItem.key] = operateItem.data;
        });
      }
      // 待办数据
      const params = {
        context: {
          instanceId: currTodo.InstanceId,
          method_name: currTodo.TodoKey === 'ExternalTodo' ? 'end' : item.callback_method,
          parent_id: currTodo.ParentInstanceId,
          parent_task_id: currTodo.ParentTaskId,
          service_name: currTodo.AjaxService,
          taskId: currTodo.TaskId,
          svckey: currTodo.FlowServiceKey || 'flowable',
          nodeId: currTodo.TaskKey,
        },
        args: {
          process_user: this.username,
          process_data: processData,
        },
      };
      if (currTodo.TodoKey === 'ExternalTodo') {
        params.context.service_name = 'ExternalTodo';
        params.args.url = currTodoComponent.ServiceUrl;
        params.args.service_name = currTodoComponent.ServiceName;
        params.args.method_name = item.callback_method;
      }

      // 将页面访问时间记录注入 process_data 并清空 sessionStorage
      try {
        if (this.processGrayList?.includes(this.ProcessDefinitionKey)) {
          var pageVisitRecords = JSON.parse(sessionStorage.getItem(this.pageVisitKey) || '[]');
          processData._pageVisitRecords = pageVisitRecords;
          params.args.process_data = processData;
          sessionStorage.removeItem(this.pageVisitKey);
        }


      } catch (e) {}

      // 待办提交弹窗
      let dataMsg = '';
      Object.keys(processData).forEach((key) => {
        if (typeof processData[key] === 'object') {
          return;
        }
        dataMsg += `<p> <b>${key} : ${processData[key]}</b> </p>`;
      });
      // const msg = `
      //     <p>待办名称：${currTodo.TodoName}</p>
      //     <p>待办提交数据：${dataMsg}</p>
      //     <br>
      //     <p>请确认操作的数据 <b>是否正确</b> 后提交！</p>`;
      this.$dialog
        .alert({
          message: currTodoComponent?.submitTips || '是否确认提交？',
          showCancelButton: true,
          type: 'warning',
        })
        .then(() => {
          this.todoCommit(params, currTodo.HandleUrl, todoIndex, currTodo.TaskId, currTodo, currTodoComponent, item);
        })
        .catch(() => {});
    },

    // 点击转派
    showHandoverTodo(todoIndex) {
      // this.submitTransferForm();
      this.transferDialog = true;
      this.currTodo = this.todoList[todoIndex];
      this.currTodoComponent = this.todoComponent[todoIndex];
    },

    // 提交转派
    async submitTransferForm() {
      const { currTodoComponent } = this;
      const { currTodo } = this;
      let processData = {};
      if (currTodoComponent.operateFormSchema && currTodoComponent.operateFormSchema.schema) {
        const todoForm = this.$refs[`todo-form-${currTodo.TaskId}`][0];
        processData = todoForm.getValues();
      } else {
        currTodoComponent.operateViewsData.forEach((operateItem) => {
          processData[operateItem.key] = operateItem.data;
        });
      }
      this.$refs.transferForm[0].validate(async (valid) => {
        try {
          if (valid) {
            this.transDisabled = true;
            if (currTodo.handoverMethod) {
              // go 版本走 ibrokergo 协议，method_name 固定为 TransferLogic
              if (this.currTodo.HandleUrl?.includes('nbrokergo')) {
                const path = this.currTodo.HandleUrl.match(/\/\/(\S*)(:9701)/)[1] || '';
                const goParams = {
                  Args: {},
                  TargetUser: this.transferPerson.name,
                  NowPerson: sessionStorage.getItem('userid'),
                  ProcessData: processData,
                  Ctx: {
                    InstanceId: currTodo.InstanceId,
                    MethodName: currTodo.MethodName === 'ExternalTodo' ? 'TransferLogic' : currTodo.handoverMethod,
                    ParentId: currTodo.ParentInstanceId,
                    ParentTaskId: currTodo.ParentTaskId,
                    ServiceName: currTodo.AjaxService,
                    TaskId: currTodo.TaskId,
                    NodeId: currTodo.TaskKey,
                    Svckey: currTodo.FlowServiceKey || 'flowable',
                  },
                };
                const goRes = await getDataByNbrokerGoUrl(`/${path}`, goParams);
                const { msg: excInfo } = goRes.data || {};
                if (excInfo) {
                  throw new Error(excInfo.traceback ? excInfo.traceback : excInfo);
                }
              } else {
                const { data } = await getDataByNbrokerUrl(
                  {
                    args: {
                      target_user: this.transferPerson.name,
                      now_person: sessionStorage.getItem('userid'),
                      process_data: processData,
                    },
                    context: {
                      instanceId: currTodo.InstanceId,
                      method_name: currTodo.handoverMethod,
                      parent_id: currTodo.ParentInstanceId,
                      parent_task_id: currTodo.ParentTaskId,
                      service_name: currTodo.AjaxService,
                      taskId: currTodo.TaskId,
                      svckey: currTodo.FlowServiceKey || 'flowable',
                      nodeId: currTodo.TaskKey,
                    },
                  },
                  this.currTodo.HandleUrl
                );
              }
            } else {
              await handoverTodo(
                this.transferPerson.name,
                sessionStorage.getItem('userid'),
                this.currTodo.TaskId
              );
            }
            this.transferDialog = false;
            this.transDisabled = false;
            // 转派成功：清空翻译缓存，避免离开页面后缓存无限积累
            try { pageTranslator.clearAllCache(); } catch (e) { /* ignore */ }
            this.$message.success('转派成功');
            this.$router.back();
          }
          this.$emit('fatherTodo');
        } catch (err) {
          this.transDisabled = false;
          this.$message.error(`转派失败: ${err.message}`);
        } finally {
          localStorage.removeItem(`taskId=${this.taskId}`);
          sessionStorage.removeItem(this.pageVisitKey);
          clearInterval(this.saver);
          this.refreshOneTodo(findIndex(this.todoComponent, { taskId: this.currTodo.TaskId }));
        }
      });
    },

    refreshOneTodo(index) {
      this.todoComponent.splice(index, 1);
      this.getTodoDataList();
    },

    // 处理VoiceAssistant数据更新事件
    async handleVoiceDataUpdated(eventData) {
      try {
        console.log('收到VoiceAssistant数据更新事件:', eventData);
        
        // 暂停自动保存定时器
        if (this.saver) {
          clearInterval(this.saver);
          console.log('已暂停自动保存定时器');
        }
        
        // 更新本地数据
        const { storageKey, data, updatedFields, updatedData } = eventData;
        localStorage.setItem(storageKey, JSON.stringify(data));
        
        // 找到对应的待办组件并更新表单数据
        this.todoComponent.forEach((todoItem) => {
          if (todoItem.taskId === this.taskId) {
            const todoForm = this.$refs[`todo-form-${todoItem.taskId}`];
            if (todoForm && todoForm[0]) {
              const currentValues = todoForm[0].getValues();
              const updatedValues = {
                ...currentValues,
                ...updatedData  // 使用展开运算符更新所有字段
              };
              todoForm[0].setValues(updatedValues);
              console.log(`已更新字段: ${updatedFields.join(', ')}`);
            }
          }
        });
        
        // 显示成功提示
        this.$toast({
          message: `语音助手已更新${updatedFields.join(', ')}`,
          type: 'success',
          duration: 2000
        });
        
        // 2秒后重新启动自动保存定时器
        setTimeout(() => {
          if (!this.saver) {
            this.saver = setInterval(() => {
              try {
                const todos = this.todoComponent.map(({ operateViewsData, taskId }) => {
                  const todoRef = this.$refs[`todo-form-${taskId}`][0];
                  return { operateViewsData, operateFormData: todoRef.getValues(), taskId };
                });
                localStorage.setItem(`taskId=${this.taskId}`, JSON.stringify(this.deleteNull(todos)));
              } catch (e) {}
            }, 2000);
            console.log('已重新启动自动保存定时器');
          }
        }, 2000);
        
      } catch (error) {
        console.error('处理VoiceAssistant数据更新失败:', error);
        this.$toast({
          message: '数据更新失败',
          type: 'error',
          duration: 2000
        });
      }
    },

    // 操作提交待办
    async todoCommit(params, url, index, taskId, currTodo, currTodoComponent, item) {
      try {
        this.fullscreenLoading = true;
        let queryResult = {};

        if (url?.includes('nbrokergo')) {
          const path = url.match(/\/\/(\S*)(:9701)/)[1] || '';

          const goParams = {
            Args: {},
            Ctx: {
              InstanceId: params?.context.instanceId,
              ServiceName: params?.context.service_name,
              MethodName: currTodo.TodoKey === 'ExternalTodo' ? 'End' : item.callback_method,
              ParentId: params?.context.parent_id,
              ParentTaskId: params?.context.parent_task_id,
              Svckey: params?.context.svckey || 'flowable',
              TaskId: params?.context.taskId,
            },
            ProcessData: params?.args?.process_data,
            ProcessUser: params?.args?.process_user,
          };
          if (currTodo.TodoKey === 'ExternalTodo') {
            goParams.Ctx.ServiceName = 'ExternalTodo';
            goParams.Args.Url = currTodoComponent.ServiceUrl;
            goParams.Args.ServiceName = currTodoComponent.ServiceName;
            goParams.Args.MethodName = item.callback_method;
          }
          queryResult = await getDataByNbrokerGoUrl(`/${path}`, goParams);
          const { msg: excInfo, data: result } = queryResult.data;
          if (excInfo) {
            throw new Error(excInfo.traceback ? excInfo.traceback : excInfo);
          }
          if (result && result.Code === -1 && result.Msg) {
            this.fullscreenLoading = false;
            this.$alert(result.Msg, {
              dangerouslyUseHTMLString: true,
              type: 'error',
            }).then(() => {
              this.$refs[`todo-form-${taskId}`][0].values = params.args.process_data;
            });
            return;
          }
          this.refreshOneTodo(index);
          this.fullscreenLoading = false;
          this.$message.success('待办操作成功！');
          localStorage.removeItem(`ticketId=${this.ticketId}`);
          clearInterval(this.saver);
          return;
        }
        
        if (this.isSim) {
          addEndLog({
            IbrokerUrl: url,
            InstanceId: this.instanceId,
            ProcessData: JSON.stringify(params?.args?.process_data),
            ProcessUser: params?.args?.process_user,
            ServiceName: params?.context.service_name,
            MethodName: params?.context.method_name || 'end',
            TaskDefKey: this.todoComponent[index].TaskKey,
            TicketId: this.ticketId,
            TaskId: params?.context.taskId,
          });
        }
        if (url) {
          // todo 这里修改待办的操作接口
          // queryResult = await axios.post(url, params);
          queryResult = await getDataByNbrokerUrl(params, url);
        } else {
          queryResult = await getDataByNbroker(params);
        }
        const { exc_info: excInfo, result } = queryResult.data;
        this.refreshOneTodo(index);
        if (result && result.code === -1 && result.msg) {
          this.fullscreenLoading = false;
          this.$dialog
            .alert({
              title: '提交失败',
              message: result.msg,
            })
            .then(() => {
              this.$refs[`todo-form-${taskId}`][0].values = params.args.process_data;
            });
          return;
        }
        if (excInfo) {
          throw new Error(excInfo.traceback ? excInfo.traceback : excInfo);
        }
        if (this.todoComponent[index] && this.todoComponent[index].link)
          location.href = this.todoComponent[index].link;
        // 提交成功：清空翻译缓存，避免离开页面后缓存无限积累
        try { pageTranslator.clearAllCache(); } catch (e) { /* ignore */ }
        this.$toast.success('待办操作成功！');
        this.$router.back();
        localStorage.removeItem(`taskId=${this.taskId}`);
      } catch (err) {
        Message.closeAll();
        this.$toast.fail(`待办操作失败: ${err.message}`);
        this.$router.back();
      } finally {
        this.fullscreenLoading = false;
        clearInterval(this.saver);
      }
    },
  },
};
</script>
<style scoped>
.todo-wrapper {
  width: 100vw !important;
  margin: 0;
  padding: 0;
  /* padding-bottom: 80px; */
}
.text-info {
  color: #909399;
}
.hide {
  visibility: hidden;
}

/* 待办标题区 */
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 10px;
}
.section-header__title {
  display: flex;
  align-items: center;
  gap: 8px;
}
.section-header__indicator {
  display: inline-block;
  width: 3px;
  height: 16px;
  border-radius: 2px;
  background: #0052D9;
}
.section-header__text {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.4;
}

/* 悬浮按钮统一样式 - 腾讯风格 */
.float-btn {
  position: fixed;
  z-index: 9999;
  width: 32px;
  height: 32px;
  border: 1px solid rgba(0, 82, 217, 0.35);
  color: #0052D9;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.25s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.float-btn:active {
  transform: scale(0.92);
  background: rgba(0, 82, 217, 0.1);
}
.float-btn--scroll {
  right: 12px;
  bottom: 12px;
}

/* 更多按钮 + 下拉菜单 */
.float-more-wrap {
  position: fixed;
  z-index: 9999;
  left: 12px;
  bottom: 12px;
}
.float-btn--more {
  position: relative;
}
.float-menu {
  position: absolute;
  bottom: 40px;
  left: 0;
  min-width: 120px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.14);
  overflow: hidden;
}
.float-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  transition: background 0.15s;
}
.float-menu-item:active {
  background: #f2f6ff;
}
.float-menu-item + .float-menu-item {
  border-top: 1px solid #f0f0f0;
}
.float-menu-fade-enter-active,
.float-menu-fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}
.float-menu-fade-enter,
.float-menu-fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

/* 底部操作栏 - 腾讯风格 */
.action-bar {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 6px;
  padding: 12px 16px;
  background: #fff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
  z-index: 100;
}
.action-btn {
  min-width: 88px;
  height: 36px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
}
.action-btn:active {
  transform: scale(0.96);
}
.action-btn--primary {
  background: #0052D9;
  color: #fff;
}
.action-btn--primary:active {
  background: #0044b5;
}
.action-btn--primary[disabled] {
  background: #a3c1f5;
  color: #fff;
}
.action-btn--secondary {
  background: #f2f6ff;
  color: #0052D9;
}
.action-btn--secondary:active {
  background: #dbeafe;
}
.action-btn--secondary[disabled] {
  background: #f5f5f5;
  color: #c0c4cc;
}
.action-btn--default {
  background: #f7f8fa;
  color: #323233;
  border: 1px solid #dcdee0;
}
.action-btn--default:active {
  background: #ebedf0;
}
.action-btn--danger {
  background: #fff;
  color: #ee0a24;
  border: 1px solid #ee0a24;
}
.action-btn--danger:active {
  background: #fff0f0;
}
.action-btn--danger[disabled] {
  border-color: #f5b0ba;
  color: #f5b0ba;
}

.footerDialog {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>